
export function numberToIndianWords(num: number): string {
	if (num === 0) return "Zero";

	const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
	const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
	const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

	function convertGroup(n: number): string {
		let str = "";

		if (n >= 100) {
			str += units[Math.floor(n / 100)] + " Hundred ";
			n %= 100;
		}

		if (n >= 20) {
			str += tens[Math.floor(n / 10)] + " ";
			n %= 10;
		}

		if (n >= 10) {
			str += teens[n - 10] + " ";
			n = 0;
		}

		if (n > 0) {
			str += units[n] + " ";
		}

		return str.trim();
	}

	let words = "";

	// Crores
	const crore = Math.floor(num / 10000000);
	if (crore > 0) {
		words += convertGroup(crore) + " Crore ";
		num %= 10000000;
	}

	// Lakhs
	const lakh = Math.floor(num / 100000);
	if (lakh > 0) {
		words += convertGroup(lakh) + " Lakh ";
		num %= 100000;
	}

	// Thousands
	const thousand = Math.floor(num / 1000);
	if (thousand > 0) {
		words += convertGroup(thousand) + " Thousand ";
		num %= 1000;
	}

	// Remaining
	if (num > 0) {
		words += convertGroup(num);
	}

	return words.trim();
}
